import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import Pages from '@/views/pages/List.vue';

export const pageListRoute: RouteConfig = {
  path: 'pages',
  name: 'pages',
  component: Pages,
  beforeEnter: (to, from, next) => {
    store
      .dispatch('pages/list', {
        ...baseFilters(to),
        noSlots: true,
        order: 'priority',
        desc: false
      })
      .then(() => {
        store.commit('breadcrumbs/set', [{ text: 'Strony', disabled: true }]);
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać listy stron.' }));
  }
};

export const pagesBySlotRoute: RouteConfig = {
  path: 'pages/:slot',
  name: 'pagesBySlot',
  component: Pages,
  beforeEnter: (to, from, next) => {
    const slots = to.params.slot;
    store
      .dispatch('pages/list', {
        ...baseFilters(to),
        slots: [slots],
        order: 'priority',
        desc: false
      })
      .then(() => {
        store.commit('breadcrumbs/set', [{ text: 'Strony', disabled: true }]);
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać listy stron.' }));
  }
};
